/* eslint-disable */
export default {
  header: 'Contactar con el servicio de asistencia técnica',
  toggleTitle: '1. Active el modo de seguimiento de errores.',
  toggleDescription:
    'Esto nos ayudará a localizar sus problemas, pero puede afectar ligeramente el rendimiento de su aplicación.',
  downloadTitle:
    '2. Descargue el registro de errores cuando haya replicado el problema.',
  downloadButton: 'Descargar',
  downloadDisabledTitle:
    'Active el modo de seguimiento de errores para poder descargar el registro de errores.',
  sendTitle: '3. Envíe el registro al equipo de asistencia.',
  createSupportTicket: 'Cree un ticket de soporte',
  sendDescription:
    ' para ponerse en contacto con nuestro equipo de asistencia. A continuación, envíe el registro al equipo de asistencia para solucionar el problema.',
  privacyNotice:
    'Al descargar y enviarnos el registro, acepta que RingCentral acceda a cierta información relacionada con los registros con el fin de solucionar problemas y gestionar errores. Para obtener más información sobre cómo RingCentral procesa los datos personales, consulte las ',
  privacyNoticeLink: 'Condiciones del servicio',
  and: ' y el ',
  privacyNoticeEnd: 'Aviso de privacidad.',
  needLeavePage:
    'Puede abandonar esta página mientras se ejecuta el seguimiento de errores. Cuando haya replicado el problema, vuelva a esta página y descargue los archivos de registro.',
  downloading: 'Descargando',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
